"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-xs font-sans tracking-[0.2em] uppercase text-muted-foreground hover:text-primary transition-colors">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/ProjectsPage" className="text-xs font-sans tracking-[0.2em] uppercase text-muted-foreground hover:text-primary transition-colors">Projects</Link>
        </li>
        <li data-index={2}>
          <Link to="/AboutUsPage" className="text-xs font-sans tracking-[0.2em] uppercase text-muted-foreground hover:text-primary transition-colors">About Us</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-xs font-sans tracking-[0.2em] uppercase text-muted-foreground hover:text-primary transition-colors inline-flex items-center">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ["New Construction", "Luxury Remodels", "Home Additions", "ADU Conversions", "Design-Build"];
  return <footer data-section-id="170227" id="footer" className="bg-background text-foreground pt-12 pb-6 px-6 md:px-12 border-t border-border/30">
      <div className="max-w-7xl mx-auto">
        

        {}
        <div className="mt-12 pt-6 border-t border-border/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col gap-2">
            <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground text-center md:text-left">
              Serving Pasadena • Glendale • La Cañada • Arcadia • and surrounding communities
            </p>
            <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground text-center md:text-left">© 2026&nbsp;R&amp;M Builders Inc. Architectural Precision.</p>
          </div>
          <div className="flex items-center gap-6 text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground">
            <Link to="#" className="hover:text-primary transition-colors">Privacy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>;
}